(() => {
  const messages = [
    'Darmowa dostawa aktywna · Dodaj jeszcze 1 produkt i otrzymaj 10% rabatu',
    '10% rabatu aktywne · Dodaj jeszcze 1 produkt i otrzymaj 15% rabatu',
    '15% rabatu aktywne · Dodaj jeszcze 1 produkt i otrzymaj 20% rabatu',
    '20% rabatu aktywne · Osiągnięto najwyższy próg rabatowy'
  ];

  const protectedShippingHandle = 'forsendelsesbeskyttelse-1';
  const protectedShippingProductId = '15717801558364';

  const getEligibleCount = (cart) => (cart.items || []).reduce((total, item) => {
    const isProtectedShipping =
      item.handle === protectedShippingHandle ||
      String(item.product_id) === protectedShippingProductId;

    return isProtectedShipping ? total : total + (Number(item.quantity) || 0);
  }, 0);

  const getStage = (count) => count >= 4 ? 3 : count >= 3 ? 2 : count >= 2 ? 1 : 0;

  const updateBars = (count) => {
    const stage = getStage(count);
    document.querySelectorAll('[data-norliva-cart-rewards]').forEach((bar) => {
      bar.dataset.itemCount = String(count);
      bar.dataset.stage = String(stage);
      bar.classList.toggle('is-empty', count === 0);

      const message = bar.querySelector('[data-norliva-reward-message]');
      if (message && message.textContent.trim() !== messages[stage]) {
        message.textContent = messages[stage];
      }

      const progress = bar.querySelector('[role="progressbar"]');
      if (progress) progress.setAttribute('aria-valuenow', String(stage));

      bar.querySelectorAll('[data-reward-step]').forEach((step) => {
        step.classList.toggle('is-active', Number(step.dataset.rewardStep) <= stage);
      });
    });
  };

  let requestNumber = 0;
  const refresh = () => {
    const currentRequest = ++requestNumber;
    const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';

    fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((cart) => {
        if (currentRequest === requestNumber) updateBars(getEligibleCount(cart));
      })
      .catch(() => {});
  };

  let refreshTimer;
  const scheduleRefresh = (delay = 120) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const observeCart = () => {
    document.querySelectorAll('[data-products]').forEach((container) => {
      if (container.dataset.norlivaRewardsObserved) return;
      container.dataset.norlivaRewardsObserved = 'true';
      new MutationObserver(() => scheduleRefresh()).observe(container, {
        childList: true,
        subtree: true
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    observeCart();
    refresh();
  });

  ['cart:build', 'cart:updated', 'cart:change', 'ajaxProduct:added'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      observeCart();
      scheduleRefresh(60);
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.js-qty__adjust, [data-qty-adjust], [data-cart-remove]')) {
      scheduleRefresh(300);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[name="updates[]"], .js-qty__num')) {
      scheduleRefresh(300);
    }
  });
})();